import React from 'react';
import { View, Text, StyleSheet } from '../Primitives'


// const charter = {requestId:2345, title:'Your Charter Request',aircraftName:'Boeing 747',carrier:'Virgin Airlines Australia',maxPassengers:15}

const boxStyle = StyleSheet.create({
    flexContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        fontFamily: 'RobotoRegular',
    },
    flexBox: {
        display: 'flex',
        flex: 1,
        marginBottom: 5
    },
    flexBoxBold: {
        display: 'flex',
        flex: 1,
        marginBottom: 5,
        fontFamily: 'RobotoBold'
    },
    parentBox: {
        display: 'flex',
        flex: 1,
    },
    leftText: {
        fontSize: 12,
    },
    rightText: {
        fontSize: 12,

    },
    jbNum: {
        fontSize: 15,
    },
    statusText: {
        fontSize: 11,
    }

})
const HeaderDetails = ({ charter, auth }) => {


    let aircraftList = {};

    if (charter.bid && charter.bid.routes) {
        charter.bid.routes.map(route => route.aircraft.map(aircraft => aircraftList[aircraft.id] = aircraft));
    }

    const itineraryShowPrice = auth.role === 'Supplier' ? false : charter.clientDepartment ? charter.clientDepartment.itineraryShowPrice : charter.client.itineraryShowPrice;
    const canViewSupplier = auth.role === "Supplier" ? true : charter.clientDepartment ? charter.clientDepartment.itineraryShowSupplier : charter.client.itineraryShowSupplier;
   
    const currency = charter.bid ? charter.bid.currency : '';
    const bidPrice = charter.bid ? (Number(charter.bid.price) || 0) : 0;
    const margin = charter.bid ? (Number(charter.bid.withMargin) || 0) : 0;
    const total = bidPrice > margin ? bidPrice + margin : margin;
    const price = charter.bid ? `(${currency}) $${total.toFixed(2)}` : "";

    return <View style={boxStyle.parentBox}>


        <View style={boxStyle.flexContainer}>
            <View style={boxStyle.flexBox}>
                <Text style={boxStyle.leftText}>Reference Number:</Text>
            </View>
            <View style={boxStyle.flexBoxBold}>
                <Text style={boxStyle.jbNum}>JB{charter.jobReference}</Text>
            </View>
        </View>
        <View style={boxStyle.flexContainer}>
            <View style={boxStyle.flexBox}>
                <Text style={boxStyle.leftText}>Charter Status:</Text>
            </View>
            <View style={boxStyle.flexBoxBold}>
                <Text style={boxStyle.statusText}>{charter.status}</Text>
            </View>
        </View>
        {canViewSupplier ? <View style={boxStyle.flexContainer}>
            <View style={boxStyle.flexBox}>
                <Text style={boxStyle.leftText}>Aircraft Operated By:</Text>
            </View>
            <View style={boxStyle.flexBoxBold}>
                <Text style={boxStyle.rightText}>{charter.bid && charter.bid.supplier ? charter.bid.supplier.companyName : ''}</Text>
            </View>
        </View> : null}

        {itineraryShowPrice ? <View style={boxStyle.flexContainer}>
            <View style={boxStyle.flexBox}>
                <Text style={boxStyle.leftText}>Total Charter Cost:</Text>
            </View>
            <View style={boxStyle.flexBoxBold}>
                <Text style={boxStyle.leftText}>{price} <Text style={{ fontSize: 8 }}>(EX GST)</Text></Text>                             
            </View>
        </View> : null}
        <View style={boxStyle.flexContainer}>
            <View style={boxStyle.flexBox}>
            <Text style={boxStyle.leftText}>PO/WO Number:</Text>
            </View>
            <View style={boxStyle.flexBoxBold}>
            <Text style={boxStyle.leftText}>{charter.purchaseOrderNumber}</Text>
            </View>
        </View>

    </View>
}
export default HeaderDetails;